import React from 'react';
import { Helmet } from 'react-helmet';
import { useSiteSettings } from '../hooks/useSiteSettings';

const DigitalRightsPage = () => {
  const { site_name } = useSiteSettings();

  return (
    <>
      <Helmet>
        <title>الحقوق الرقمية | {site_name || ''}</title>
      </Helmet>
      <div className="section">
        <h1 className="section-title">الحقوق الرقمية</h1>
        <div style={{ maxWidth: 800, margin: '0 auto', textAlign: 'right' }}>
          <p>مقدمة عن الحقوق الرقمية...</p>
        </div>
      </div>
    </>
  );
};

export default DigitalRightsPage; 